export function formatCurrency(value: number, decimal: number = 0, hideTag: boolean = false) {
  const formatter = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: decimal,
  })

  // hilangkan rp?
  if (hideTag) return formatter.format(value).replace(/Rp\s?/, '')
  return formatter.format(value)
}

/**
 * Hitung harga jual marketplace
 * @param {number} basePrice - harga dasar barang
 * @param {number} profitPercent - persen keuntungan yang diinginkan (misal 20 untuk 20%)
 * @param {number} adminPercent - persen biaya admin marketplace (misal 15 untuk 15%)
 * @param {number} fixedFee - biaya tetap (misal 1250)
 * @param {number} minProfit - keuntungan minimal yang harus dicapai
 * @returns {number} harga jual minimal
 */
export function calculateSellingPrice(
  basePrice: number,
  profitPercent: number = 20,
  adminPercent: number = 15,
  fixedFee: number = 1250,
  minProfit: number = 20000,
): number {
  const profitTarget = (profitPercent / 100) * basePrice

  // penerimaan bersih = (1 - admin%) * X - fixedFee
  // keuntungan = penerimaan bersih - basePrice
  // rumus: (1 - admin%) * X - fixedFee - basePrice >= targetProfit
  const requiredRevenue1 = basePrice + profitTarget + fixedFee
  const requiredRevenue2 = basePrice + minProfit + fixedFee

  // revenue / (1 - admin%)
  const price1 = requiredRevenue1 / (1 - adminPercent / 100)
  const price2 = requiredRevenue2 / (1 - adminPercent / 100)

  // ambil harga jual yang lebih besar
  return Math.ceil(Math.max(price1, price2))
}

export const formatRateNumber = (rate: number | string) => {
  return Math.round(Number(rate) * 100) / 100
}
